(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-futsal/assets/javascripts/init-box.js') >= 0) return;  svs.modules.push('/components/themes/sport-futsal/assets/javascripts/init-box.js'); "use strict";

(function (svs) {
  svs = svs || {};
  svs.themes = svs.themes || {};
  svs.themes.sport_futsal = svs.themes.sport_futsal || {};

  svs.themes.sport_futsal.initStatusStart = function (data) {
    if (svs.themes.sport_futsal.isLive(data.status.id)) {
      if (data.status.id === 1) {
        return '<div class="brick match-status brick-active f-condensed align-center">1:A</div>';
      } else if (data.status.id === 2) {
        return '<div class="brick match-status brick-active f-condensed align-center">2:A</div>';
      } else if (_.contains([14, 16, 17, 18], data.status.id)) {
        return '<div class="brick match-status brick-active f-condensed align-center">PAUS</div>';
      } else if (data.status.id === 22) {
        return '<div class="brick match-status brick-active f-condensed align-center">STR</div>';
      } else if (_.contains([19, 20, 21], data.status.id)) {
        return '<div class="brick match-status brick-active f-condensed align-center">ÖT</div>';
      }

      return '<div class="brick match-status brick-active f-condensed align-center">1:A</div>';
    } else if (svs.themes.sport_futsal.isEnded(data.status.id)) {
      if (_.contains([32, 33, 41], data.status.id)) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">SLUT</div>';
      } else if (data.status.id === 28) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">UPPH</div>';
      }

      return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">FT</div>';
    }

    return '';
  };


  svs.themes.sport_futsal.hasMatchMinutes = function () {
    return false;
  };
})(svs);
 })(window);